<template>
    <Card>
        <template #content>
            <Panel v-if="step === '1'" :header="`${label('Debrief')} Type`">
                <div class="flex align-items-center justify-content-center ">
                    <h5 class="mt-2">
                        Please choose the type of {{ label('Debrief').toLowerCase() }} from the options below:
                    </h5>
                </div>

                <div>
                    <div class="flex align-items-stretch flex-wrap align-items-center justify-content-center" style="min-height: 200px">
                        <div class="flex align-items-center justify-content-center m-2" style="min-width: 200px; min-height: 50px">
                            <Button label="Incident" icon="pi pi-bell" @click="goToIncident" raised rounded></Button>
                        </div>
                        <div class="flex align-items-center justify-content-center m-2" style="min-width: 200px; min-height: 50px">
                            <Button label="Training" icon="pi pi-book" @click="goToTraining" raised rounded></Button>
                        </div>
                        <div class="flex align-items-center justify-content-center m-2" style="min-width: 200px; min-height: 50px">
                            <Button label="Exercise" icon="pi pi-file" @click="goToExercise" raised rounded></Button>
                        </div>

                    </div>

                    <div v-if="!isMobile" style="min-height: 200px">
                        <div class="flex align-items-center justify-content-center m-2">
                            Your screen should be big enough to enjoy the desktop interface:
                        </div>
                        <div class="flex align-items-center justify-content-center m-2 mt-3">
                            <Button label="Desktop size" icon="pi pi-desktop" @click="goToDesktopDebrief" raised rounded></Button>
                        </div>

                    </div>
                </div>
            </Panel>
            <Panel v-else-if="step === '2_training'" header="Training">

                incidentLoading: {{incidentLoading}}

                <div v-if="incidentLoading">
                    <ScaleLoader />
                </div>
                <div v-else>
                    <div v-if="incidentList.length === 0">
                        <div class="col-12">
                            No training was found for today. Do you want to create a new one?
                        </div>
                        <div class="col-12">
                            <Button
                                label="Create"
                                icon="pi pi-file-plus"
                                class="p-button-rounded p-button-success mr-2"
                                v-tooltip="'Create'"
                                @click="createTrainingExercise(3)"
                            />
                        </div>
                    </div>

                    <div v-if="incidentList.length > 0">
                        <div class="col-12">
                            <Button
                                label="Create"
                                icon="pi pi-file-plus"
                                class="p-button-rounded p-button-success mr-2"
                                v-tooltip="'Create'"
                                @click="createTrainingExercise(3)"
                            />
                        </div>

                        <div v-if="isMobile" class="col-12">

                            <div class="grid">
                                <template v-for="incident in incidentList" :key="incident.id">
                                    <div class="col-9" @click="selectIncident(incident)" style="cursor: pointer">
                                        {{formatDate(incident.incident_date)}}
                                    </div>
                                    <div class="col-2"><Button
                                        icon="pi pi-arrow-right"
                                        class="p-button-rounded p-button-success mr-2"
                                        v-tooltip="'Use this one'"
                                        @click="selectIncident(incident)"
                                    /></div>
                                </template>
                            </div>

                        </div>
                        <div v-else>
                            <DataTable
                                :value="incidentList"
                                ref="dt"
                                dataKey="id"
                                :totalRecords="incidentList.length"
                                :loading="incidentLoading"
                                removableSort
                            >
                                <template #empty> No Incindent available. </template>
                                <Column field="incident_number" header="Incident Number" />
                                <Column field="incident_date" header="Incident Date" >

                                    <template #body="slotProps">
                                        {{formatDate(slotProps.data.incident_date)}}
                                    </template>

                                </Column>
                                <Column field="actions" header="ACTIONS" style="max-width: 6rem">
                                    <template #body="slotProps">
                                        <Button
                                            icon="pi pi-arrow-right"
                                            class="p-button-rounded p-button-success mr-2"
                                            v-tooltip="'Use this one'"
                                            @click="selectIncident(slotProps.data)"
                                        />
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>

                <template #footer >
                    <div class="grid">

                        <div class="flex justify-content-start col-12">
                            <Button icon="pi pi-arrow-left" class="p-button-warning" @click="goHome" raised rounded></Button>
                        </div>

                    </div>
                </template>
            </Panel>
            <Panel v-else-if="step === '2_exercise'" header="Exercise">

                <div v-if="incidentLoading">
                    <ScaleLoader />
                </div>
                <div v-else>
                    <div v-if="incidentList.length === 0">
                        <div class="col-12">
                            No exercise was found for today. Do you want to create a new one?
                        </div>
                        <div class="col-12">
                            <Button
                                label="Create"
                                icon="pi pi-file-plus"
                                class="p-button-rounded p-button-success mr-2"
                                v-tooltip="'Create'"
                                @click="createTrainingExercise(2)"
                            />
                        </div>
                    </div>

                    <div v-if="incidentList.length > 0">
                        <div class="col-12">
                            <Button
                                label="Create"
                                icon="pi pi-file-plus"
                                class="p-button-rounded p-button-success mr-2"
                                v-tooltip="'Create'"
                                @click="createTrainingExercise(2)"
                            />
                        </div>

                        <div v-if="isMobile" class="col-12">

                            <div class="grid">
                                <template v-for="incident in incidentList" :key="incident.id">
                                    <div class="col-9" @click="selectIncident(incident)" style="cursor: pointer">
                                        {{formatDate(incident.incident_date)}}
                                    </div>
                                    <div class="col-2"><Button
                                        icon="pi pi-arrow-right"
                                        class="p-button-rounded p-button-success mr-2"
                                        v-tooltip="'Use this one'"
                                        @click="selectIncident(incident)"
                                    /></div>
                                </template>
                            </div>

                        </div>
                        <div v-else>
                            <DataTable
                                :value="incidentList"
                                ref="dt"
                                dataKey="id"
                                :totalRecords="incidentList.length"
                                :loading="incidentLoading"
                                removableSort
                            >
                                <template #empty> No Incindent available. </template>
                                <Column field="incident_number" header="Incident Number" />
                                <Column field="incident_date" header="Incident Date" >

                                    <template #body="slotProps">
                                        {{formatDate(slotProps.data.incident_date)}}
                                    </template>

                                </Column>
                                <Column field="actions" header="ACTIONS" style="max-width: 6rem">
                                    <template #body="slotProps">
                                        <Button
                                            icon="pi pi-arrow-right"
                                            class="p-button-rounded p-button-success mr-2"
                                            v-tooltip="'Use this one'"
                                            @click="selectIncident(slotProps.data)"
                                        />
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>

                <template #footer >
                    <div class="grid">

                        <div class="flex justify-content-start col-12">
                            <Button icon="pi pi-arrow-left" class="p-button-warning" @click="goHome" raised rounded></Button>
                        </div>

                    </div>
                </template>
            </Panel>
            <Panel v-else-if="step === '2_incident'" header="Incident">
                <div class="flex align-items-center justify-content-center ">

                    <div class="grid">
                        <div class="field col-12">
                            <label for="incidentNumber" class="ml-2">
                                Select or create the Incident:
                            </label>
                        </div>
                        <div class="col-9">
                            <InputText
                                v-model="incidentNumber"
                                id="incidentNumber"
                                type="text"
                                placeholder="Incident Number"
                                @update:modelValue="incidentNumberChanged"
                            />
                        </div>
                        <div class="col-3">
                            <Button icon="pi pi-filter" raised rounded class="ml-2" :loading="incidentLoading" @click="filterIncidents"></Button>
                        </div>

                        <div v-if="incidentNumber.length > 0 && incidentsFiltered" class="col-12 flex align-items-center justify-content-center">
                            <Button
                                label="Create"
                                icon="pi pi-save"
                                class="p-button-rounded p-button-success mr-2"
                                v-tooltip="'Use this one'"
                                @click="createAndSelectIncident(incidentNumber)"
                                :loading="incidentLoading"
                                :disabled="incidentNumberExists"
                            />
                        </div>

                        <div v-if="incidentList.length > 0">
                            <div v-if="isMobile" class="col-12">

                                <div class="grid">
                                    <template v-for="incident in incidentList" :key="incident.id">
                                        <div class="col-9" @click="selectIncident(incident)" style="cursor: pointer">
                                            {{incident.incident_number}}
                                        </div>
                                        <div class="col-2"><Button
                                            icon="pi pi-arrow-right"
                                            class="p-button-rounded p-button-success mr-2"
                                            v-tooltip="'Use this one'"
                                            @click="selectIncident(incident)"
                                        /></div>
                                    </template>
                                </div>

                            </div>
                            <div v-else>
                                <DataTable
                                    :value="incidentList"
                                    ref="dt"
                                    dataKey="id"
                                    :totalRecords="incidentList.length"
                                    :loading="incidentLoading"
                                    removableSort
                                >
                                    <template #empty> No Incindent available. </template>
                                    <Column field="incident_number" header="Incident Number" />
                                    <Column field="incident_date" header="Incident Date" >

                                        <template #body="slotProps">
                                            {{formatDate(slotProps.data.incident_date)}}
                                        </template>

                                    </Column>
                                    <Column field="actions" header="ACTIONS" style="max-width: 6rem">
                                        <template #body="slotProps">
                                            <Button
                                                icon="pi pi-arrow-right"
                                                class="p-button-rounded p-button-success mr-2"
                                                v-tooltip="'Use this one'"
                                                @click="selectIncident(slotProps.data)"
                                            />
                                        </template>
                                    </Column>
                                </DataTable>
                            </div>
                        </div>

                    </div>
                </div>

                <template #footer >
                    <div class="grid">

                        <div class="flex justify-content-start col-12">
                            <Button icon="pi pi-arrow-left" class="p-button-warning" @click="goHome" raised rounded></Button>
                        </div>

                    </div>
                </template>
            </Panel>
            <Panel v-else-if="step === '3'" header="Learning identified">
                <div class="grid">

                    <template v-if="incident.category === '1'">
                        <div class="col-12 flex align-items-center justify-content-center">
                            Incident number selected:
                        </div>

                        <div class="col-12 flex align-items-center justify-content-center border-solid border-primary-500">
                            <b>{{incident.incident_number}}</b>
                        </div>
                    </template>
                    <template v-else-if="incident.category === '2'">
                        <div class="col-12 flex align-items-center justify-content-center">
                            Exercise selected:
                        </div>

                        <div class="col-12 flex align-items-center justify-content-center border-solid border-primary-500">
                            <b>{{formatDate(incident.incident_date)}}</b>
                        </div>
                    </template>
                    <template v-else-if="incident.category === '3'">
                        <div class="col-12 flex align-items-center justify-content-center">
                            Training selected:
                        </div>

                        <div class="col-12 flex align-items-center justify-content-center border-solid border-primary-500">
                            <b>{{formatDate(incident.incident_date)}}</b>
                        </div>
                    </template>

                    <div class="col-12 flex align-items-center justify-content-center">
                        Was learning identified?
                    </div>

                    <div class="col-12 flex align-items-center justify-content-center">
                        <Button
                            label="Yes"
                            icon="pi pi-sliders-v"
                            @click="goToAddLearning"
                            raised
                            rounded
                            class="mr-2"
                            :loading="learningOutcomeSaving"
                        />
                        <Button
                            label="No"
                            icon="pi pi-star-fill"
                            @click="noLearningOutcomes"
                            raised
                            rounded
                            :loading="learningOutcomeSaving"
                        />
                    </div>
                </div>

                <template #footer >
                    <div class="grid">
                        <div class="flex justify-content-start col-12">
                            <Button
                                v-if="incident.category === '2'"
                                icon="pi pi-arrow-left"
                                class="p-button-warning"
                                @click="goToExercise"
                                raised
                                rounded
                                :loading="learningOutcomeSaving"
                            />
                            <Button
                                v-if="incident.category === '1'"
                                icon="pi pi-arrow-left"
                                class="p-button-warning"
                                @click="goToIncident"
                                raised
                                rounded
                                :loading="learningOutcomeSaving"
                            />
                            <Button
                                v-if="incident.category === '3'"
                                icon="pi pi-arrow-left"
                                class="p-button-warning"
                                @click="goToTraining"
                                raised
                                rounded
                                :loading="learningOutcomeSaving"
                            />
                        </div>
                    </div>
                </template>
            </Panel>
            <Panel v-else-if="step === '4'" header="Add Learning Outcome">
                <div class="grid">
                    <div class="flex flex-column col-12 field mt-0 mb-0">
                        <label class="mb-2" for="theme_id">Theme</label>
                        <VueTreeSelect
                            id="theme_id"
                            class="p-multiselect p-component"
                            v-model="learningOutcome.theme_id"
                            :options="themes"
                            placeholder="Select a Theme"
                            value-consists-of="ALL"
                            :multiple="false"
                        />
                    </div>
                    <div class="flex flex-column col-12 field mt-0 mb-0">
                        <label class="mb-2" for="source_id">Source</label>
                        <VueTreeSelect
                            id="theme_id"
                            class="p-multiselect p-component"
                            v-model="learningOutcome.source_id"
                            :options="sources"
                            placeholder="Select a Source"
                            value-consists-of="ALL"
                            :multiple="false"
                        />
                    </div>
                    <div class="flex flex-column col-12 field mt-0 mb-0">
                        <label class="mb-2" for="incident_category">Type</label>
                        <Dropdown
                            id="incident_category"
                            v-model="learningOutcome.outcome_type"
                            :options="outcomeTypes"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select a Type"
                            class="mb-1"
                            :showClear="true"
                        />
                    </div>

                    <div class="flex flex-column col-12 field mt-0 mb-0">
                        <label class="mb-2" for="details">Details</label>
                        <BaseEditor
                            v-model="learningOutcome.details"
                        />
                    </div>
                </div>

                <template #footer >
                    <div class="grid">
                        <div class="flex justify-content-start col-6">
                            <Button
                                icon="pi pi-arrow-left"
                                class="p-button-warning mr-2"
                                @click="goToLearningIdentified"
                                raised
                                rounded
                                :loading="learningOutcomeSaving"
                            />
                        </div>
                        <div class="flex justify-content-end col-6">
                            <Button
                                icon="pi pi-paperclip"
                                class="p-button-help"
                                @click="goToFileUpload"
                                raised
                                rounded
                                :loading="learningOutcomeSaving"
                                :disabled="!isValid"
                            />
                            <Button
                                icon="pi pi-save"
                                class="p-button-success ml-2"
                                @click="saveLearningOutcome"
                                raised
                                rounded
                                :loading="learningOutcomeSaving"
                                :disabled="!isValid"
                            />
                        </div>

                    </div>
                </template>
            </Panel>

            <Panel v-else-if="step === '5'" header="File upload">
                <div class="grid">
                    <div class="flex flex-column col-12 field mt-0 mb-0">

                        <FileUpload
                            class="fileUploader"
                            @uploader="onFileUpload"
                            @select="onSelectedFiles"
                            :multiple="true"
                            :maxFileSize="5000000"
                            :accept="acceptedFormats"
                            :custom-upload="true"
                            auto
                        >
                            <template #header="{ chooseCallback }">
                                <div class="flex flex-wrap justify-content-between align-items-center flex-1 gap-2">
                                    <div class="flex gap-2">
                                        <Button @click="chooseCallback()" icon="pi pi-file" rounded outlined label="Choose" :loading="learningOutcomeSaving"></Button>
                                        <!--
                                        <Button @click="uploadEvent(uploadCallback)" icon="pi pi-cloud-upload" label="Upload" rounded outlined severity="success" :disabled="!files || files.length === 0"></Button>
                                        <Button @click="clearCallback()" icon="pi pi-times" rounded outlined severity="danger" label="Clear" :disabled="!files || files.length === 0"></Button>
                                        -->
                                    </div>
                                </div>
                            </template>
                            <template #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">
                                <div v-if="files.length > 0">
                                    <h5>Pending</h5>
                                    <div class="flex flex-wrap p-0 sm:p-5 gap-5">
                                        <div v-for="(file, index) of files" :key="file.name + file.type + file.size" class="card m-0 px-6 flex flex-column border-1 surface-border align-items-center gap-3">
                                            <div>
                                                <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" />
                                            </div>
                                            <span class="font-semibold">{{ file.name }}</span>
                                            <div>{{ formatSize(file.size) }}</div>
                                            <Badge value="Pending" severity="warning" />
                                            <Button icon="pi pi-times" @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined rounded  severity="danger" />
                                        </div>
                                    </div>
                                </div>

                                <div v-if="uploadedFiles.length > 0">
                                    <h5>Completed</h5>
                                    <div class="flex flex-wrap p-0 sm:p-5 gap-5">
                                        <div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size" class="card m-0 px-6 flex flex-column border-1 surface-border align-items-center gap-3">
                                            <div>
                                                <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" />
                                            </div>
                                            <span class="font-semibold">{{ file.name }}</span>
                                            <div>{{ formatSize(file.size) }}</div>
                                            <Badge value="Completed" class="mt-3" severity="success" />
                                            <Button icon="pi pi-times" @click="removeUploadedFileCallback(index)" outlined rounded  severity="danger" />
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template #empty>
                                <div class="flex align-items-center justify-content-center flex-column">
                                    <i class="pi pi-cloud-upload border-2 border-circle p-5 text-8xl text-400 border-400" />
                                    <p class="mt-4 mb-0">Drag and drop files to here to upload.</p>
                                </div>
                            </template>
                        </FileUpload>
                    </div>

                    <div v-if="learningOutcomeSaving" class="col-12 align-content-center align-items-center justify-content-center flex-column">
                        <ScaleLoader />
                    </div>
                    <div v-else class=" col-12 field mt-0 mb-0">
                        File uploaded: <b>{{learningOutcome.attachments.length}}</b>
                    </div>
                </div>

                <template #footer >
                    <div class="grid">
                        <div class="flex justify-content-start col-6">
                            <Button
                                icon="pi pi-arrow-left"
                                class="p-button-warning mr-2"
                                @click="backToLearning"
                                raised
                                rounded
                                :loading="learningOutcomeSaving" />
                        </div>
                        <div class="flex justify-content-end col-6">

                            <Button
                                icon="pi pi-save"
                                class="p-button-success"
                                @click="saveLearningOutcome"
                                raised
                                rounded
                                :loading="learningOutcomeSaving"
                            />
                        </div>

                    </div>
                </template>
            </Panel>
            <Panel v-else-if="step === '6'" header="Confirm">
                <div class="grid">

                    <h6 v-if="debrief && debrief.learning === 0" class="col-12 flex align-items-center justify-content-center">
                        {{ label('Debrief') }} recorded
                    </h6>
                    <div v-if="debrief && debrief.learning === 1" class="col-12 flex align-items-center justify-content-center">
                        <div>Learning outcomes created:</div>
                        <div class="ml-1"><b>{{debrief.learning_outcome.length}}</b></div>
                    </div>

                    <div v-if="debrief.learning_outcome.length > 0" class="col-12 grid ml-0 mr-2">
                        <div class="col-10 lo-header">
                            LO details (trunc)
                        </div>
                        <div class="col-2 flex justify-content-end lo-header">
                            <i class="pi pi-paperclip" style="color: green"></i>
                        </div>

                        <template v-for="learning_outcome in debrief.learning_outcome" :key="learning_outcome.id">
                            <div class="col-10">
                                {{ shortDetails(stripTags(learning_outcome.details)) }}
                            </div>
                            <div class="col-2 flex justify-content-end">
                                {{learning_outcome.attachments.length}}
                            </div>
                        </template>
                    </div>

                </div>

                <template #footer >
                    <div class="grid">
                        <div class="flex justify-content-end col-12">
                            <Button
                                v-if="debrief.learning === 1"
                                icon="pi pi pi-fw pi-plus "
                                class="mr-2"
                                @click="addAnotherLearning"
                                raised
                                rounded
                            />
                            <Button
                                icon="pi pi-thumbs-up-fill"
                                class="p-button-success"
                                @click="goConfirmation"
                                raised
                                rounded
                            />
                        </div>
                    </div>
                </template>
            </Panel>

            <Panel v-else-if="step === 'jobDone'" header="Thanks">

                <div class="flex align-items-center justify-content-center m-2">
                    <i class="pi pi-thumbs-up-fill" style="font-size: 2.5rem; color: green"></i>
                </div>

                <div class="flex align-items-center justify-content-center m-2 text-lg	mt-4">
                    Thank you for your {{ label('Debrief') }}!
                </div>

                <Divider />

                <div class="flex align-items-center justify-content-center m-2">
                    <Button
                        icon="pi pi-fast-backward"
                        :label="`Add a new ${label('Debrief')}`"
                        @click="goHome"
                        raised
                        rounded
                    />
                </div>


            </Panel>
        </template>
    </Card>
</template>

<script setup>

import { computed, onMounted, ref } from 'vue';
import { authStore } from '@/store/global-stores';
import { authApi } from '@/utilities/axios';
import { showToast } from '@/utilities/toast-handler';
import { useWindowSize } from '@vueuse/core'
import { DateTime } from 'luxon';
import { useRouter } from 'vue-router';
import { usePrimeVue } from 'primevue/config';
import { useLabels } from '@/composables/LabelComposable';

const $primevue = usePrimeVue();
const { label } = useLabels();

const { width, height } = useWindowSize()
const router = useRouter();

const step = ref('1')

onMounted(() => {
    console.log('[onMounted] FAST procedure')
    console.log('debrief', debrief)
    console.log(`Screen ${width.value} x ${height.value}`)
    loadThemes()
    loadSources()

    cleanAndSetup()
});

function shortDetails (string) {
    return string.substring(0, 20);
}

const acceptedFormats =
    'image/*,.pptx, .xlsx, .xltx, .docx, .ppt, .xls, .xlt, .doc, .eml, .jpeg, .jpg, .jpe, .png, .gif, .tif, .tiff, .csv, .rtf, .pdf, .odc, .otc, .odb, .odf, .odft, .odg, .otg, .odi, .oti, .odp, .otp, .ods, .ots, .odt, .odm, .ott, .oth, .dwg, .msg';


const isMobile = computed(() => {
    return width.value <= 1000
});

const isValid = computed(() => {
    console.log('step', step)

    if (step.value === '4') {
        return learningOutcome.value.theme_id > 0 &&
            learningOutcome.value.source_id > 0 &&
            learningOutcome.value.outcome_type > 0 &&
            learningOutcome.value.details !== null &&
            learningOutcome.value.details.length > 0;
    }

    return true
})

const company_id = computed(() => {
    return authStore.getLoggedUserCompanyId;
});

const incidentNumber = ref('')
const incidentLoading = ref(false)
const incidentList = ref([])
const incidentsFiltered = ref(false)
const incidentNumberExists = ref(false)
const learningOutcomeSaving = ref(false)
const unsavedData = ref(false)

const themes = ref([])
const sources = ref([])

const totalSize = ref(0);
const totalSizePercent = ref(0);
const files = ref([]);

const incident = ref({
    id: null,
    incident_number: null,
    category: null,
    incident_date: DateTime.now(),
})

const debrief = ref({
    id: null,
    incident_id: null,
    learning_outcome: [],
    company_id: company_id.value,
    appliance_id: null,
    learning: null,
    complete: false,
})

const learningOutcome = ref({
    id: null,
    debrief_id: null,
    theme_id: null,
    company_id: company_id.value,
    source_id: null,
    details: null,
    outcome_type: null,
    attachments: [],
    complete: 0,
})

const outcomeTypes = [
    {
        value: 1,
        label: 'Local Issue',
    },
    {
        value: 2,
        label: 'Service Wide',
    },
    {
        value: 3,
        label: 'Notable Practice',
    },
]

function cleanAndSetup() {
    incidentNumber.value = ''
    incidentList.value = []
    incidentsFiltered.value = false

    incident.value = {
        id: null,
        incident_number: null,
        category: null,
    }

    debrief.value = {
        id: null,
        incident_id: null,
        learning_outcome: [],
        company_id: company_id.value,
        appliance_id: null,
        learning: null,
        complete: false,
    }

    learningOutcome.value = {
        id: null,
        debrief_id: null,
        theme_id: null,
        company_id: company_id.value,
        source_id: null,
        details: null,
        outcome_type: null,
        attachments: [],
        complete: 0,
    }
}

function formatDate(dateString) {

    if (dateString && dateString.length > 0) {
        if (DateTime.fromISO(dateString).isValid) {
            return DateTime.fromISO(dateString).setLocale('en-GB').toLocaleString({
                weekday: 'short',
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            })
        } else if (DateTime.fromSQL(dateString).isValid) {
            return DateTime.fromSQL(dateString).setLocale('en-GB').toLocaleString({
                weekday: 'short',
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            })
        } else {
            console.log('formatDate',dateString, DateTime.fromSQL(dateString) )
        }
    } else {
        return ''
    }
}

function goConfirmation() {
    step.value = 'jobDone'
}

function goHome() {
    cleanAndSetup()
    step.value = '1'
}

function goToIncident() {
    step.value = '2_incident'
    incidentsFiltered.value = false
}

function goToLearningIdentified() {
    step.value = '3'
}

function addAnotherLearning() {
    learningOutcome.value.details = null
    learningOutcome.value.id = null
    learningOutcome.value.outcome_type = null
    learningOutcome.value.theme_id = null
    learningOutcome.value.source_id = null
    learningOutcome.value.attachments = []

    step.value = '4'
}

function backToLearning() {
    step.value = '4'
}

function goToAddLearning() {
    debrief.value.learning = 1
    saveDebrief().then(() => {
        step.value = '4'
    })

    console.log('learningOutcome', learningOutcome)
}

function goToConfirmation() {
    step.value = '6'
}

function goToFileUpload() {
    console.log('File upload')
    step.value = '5'
}

function goToTraining() {
    loadTrainingExercise(3)
    step.value = '2_training'
}
function goToExercise() {
    loadTrainingExercise(2)
    step.value = '2_exercise'
}

function noLearningOutcomes() {
    debrief.value.learning = 0

    saveDebrief().then(() => {
        goConfirmation()
    })
}

function saveDebrief() {
    learningOutcomeSaving.value = true
    console.log('saveDebrief')

    if (debrief.value.id === null) {
        return authApi.post('/v2/debrief', debrief.value).then((response) => {
            if (response.statusCode === 201) {
                console.log('response', response)
                learningOutcomeSaving.value = false

                debrief.value = response.data


            }
        }).catch((response) => {
            console.log('something went wrong:', response);
            showToast(response, response.data.message)
            learningOutcomeSaving.value = false
        })
    } else {
        return authApi.patch(`/v2/debrief/${debrief.value.id}`, debrief.value).then((response) => {
            if (response.statusCode === 200) {
                console.log('response', response)
                learningOutcomeSaving.value = false

                debrief.value = response.data
            }
        }).catch((response) => {
            console.log('something went wrong:', response);
            showToast(response, response.data.message)
            learningOutcomeSaving.value = false
        })
    }
}

function saveLearningOutcome() {

    learningOutcome.value.debrief_id = debrief.value.id
    learningOutcomeSaving.value = true

    console.log('saveLearningOutcome', learningOutcome.value)

    authApi.post('/v2/learning-outcome', learningOutcome.value).then((response) => {
        if (response.statusCode === 201) {
            console.log('response', response)
            learningOutcomeSaving.value = false

            debrief.value.learning_outcome.push({
                id: response.data.id,
                debrief_id: response.data.debrief_id,
                theme_id: response.data.theme_id,
                company_id: response.data.company_id,
                source_id: response.data.source_id,
                details: response.data.details,
                outcome_type: response.data.outcome_type,
                attachments: response.data.attachments,
                complete: 0,
            })

            console.log('learning outcome saved as ', response.data.id)

            debrief.value.learning_outcome.forEach((lo, index) => {
                console.log(`[${index}] => ${lo.id} - ${lo.details}`)
            })

            learningOutcome.value = response.data

            goToConfirmation()
        }
    }).catch((response) => {
        console.log('something went wrong:', response);
        showToast(response, response.data.message)
        learningOutcomeSaving.value = false
    })

    //
}

function incidentNumberChanged() {
    console.log('incidentNumberChanged', incidentNumber.value)
    incidentsFiltered.value = false
    incidentList.value = []
}

function createTrainingExercise(type) {
    console.log(`createTrainingExercise ${type}`)


    incidentLoading.value = true

    authApi.post('/v2/incident', {
        category: type,
        company_id: company_id.value,
        incident_date: DateTime.now().toISODate(),
    }).then((response) => {
        if (response.statusCode === 201) {
            console.log('response', response)

            debrief.value.incident_id = response.data.id

            incidentList.value.push(response.data)

            incidentLoading.value = false

            step.value = '3'

        }
    }).catch((response) => {
        console.log('Something went wrong:', response);
        showToast(response, response.data.message)
        learningOutcomeSaving.value = false
    })

/*
    authApi.post('/v2/incident', {
        category: type,
        incident_date: DateTime.now().toISODate(),
        company_id: company_id,
    }).then((response) => {
        if (response.statusCode === 201) {
            console.log('response', response)

            debrief.value.incident_id = response.data.id

            incidentList.value.push(response.data)

            incidentLoading.value = false

        }
    }).catch((response) => {
        console.log('Something went wrong:', response);
        showToast(response, response.data.message)
        learningOutcomeSaving.value = false
    })*/
}

function loadTrainingExercise(category) {
    console.log('loadTraining')

    incidentLoading.value = true

    authApi.get('/v2/incident', {
        params: {
            company_id: company_id.value,
            paginate: 'true',
            incident_number: incidentNumber.value,
            category: category,
            page_size: 10,
            page: 1,
            incident_date_from: DateTime.now().minus({days: 1}).toFormat('yyyy-MM-dd'),
        }
    }).then((response) => {
        console.log('response', response.data)

        incidentList.value = response.data.data

        incidentLoading.value = false

    }).catch((response) => {
        console.log('something went wrong:', response);
        showToast(response, response.data.message);
        incidentLoading.value = false
    })
}

function filterIncidents() {
    console.log('filterIncidents')

    incidentLoading.value = true
    incidentNumberExists.value = false

    authApi.get('/v2/incident', {
        params: {
            company_id: company_id.value,
            paginate: 'true',
            incident_number: incidentNumber.value,
            category: 1, // Incidents only
            page_size: 10,
            page: 1,
        }
    }).then((response) => {
        if (response.statusCode === 200) {
            console.log('response', response)

            incidentLoading.value = false

            incidentList.value = response.data.data

            response.data.data.forEach((incident) => {
                console.log('incident', incident.incident_number)

                if (incidentNumber.value === incident.incident_number) {
                    incidentNumberExists.value = true
                }
            })

            incidentsFiltered.value = true
        }
    }).catch((response) => {
        console.log('something went wrong:', response);
        showToast(response, response.data.message);
        incidentLoading.value = false
    })
}

function createAndSelectIncident(incidentNumber) {

    const incidentDate = DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss')

    authApi.post('/v2/incident', {
        incident_number: incidentNumber,
        category: 1,
        incident_date: incidentDate,
    }).then((response) => {
        if (response.statusCode === 201) {
            console.log('response', response)

            if (Object.hasOwn(response, 'data')) {
                const incidentData = response.data

                incident.value.id = incidentData.id
                incident.value.incident_number = incidentData.incident_number
                incident.value.category = incidentData.category
                incident.value.incident_date = DateTime.now().setLocale('en-GB').toFormat('yyyy-MM-dd')
                debrief.value.incident_id = incidentData.id

                incidentLoading.value = false

                goToLearningIdentified()
            }
        }
    }).catch((response) => {
        console.log('something went wrong:', response);
        incidentLoading.value = false
        showToast(response, response.data.message);
    })

    incidentLoading.value = true
}

function selectIncident(incidentData) {
    console.log('Incident selected:', incidentData)

    incident.value.id = incidentData.id
    incident.value.incident_number = incidentData.incident_number
    incident.value.category = incidentData.category
    incident.value.incident_date = incidentData.incident_date
    debrief.value.incident_id = incidentData.id
    incidentList.value = []

    incidentLoading.value = false

    goToLearningIdentified()
}

function goToDesktopDebrief() {
    router.push('/debrief/createUpdate')
}

function loadThemes() {
    themes.value = []
    authApi.get(`/v2/themes?paginate=false&company_id=${company_id.value}`)
        .then( async (response) => {
            if (response.statusCode === 200) {
                if (Object.hasOwn(response, 'data')) {
                    response.data.forEach((item) => {
                        themes.value.push(parseItems(item))
                    })
                }
            }

        }).catch((error) => {
        showToast(error, 'Failed to load the Theme list');
    });
}

function loadSources() {
    sources.value = []
    authApi.get(`/v2/sources?paginate=false&company_id=${company_id.value}`)
        .then( async (response) => {
            if (response.statusCode === 200) {
                if (Object.hasOwn(response, 'data')) {
                    response.data.forEach((item) => {
                        sources.value.push(parseItems(item))
                    })
                }
            }

        }).catch((error) => {
        showToast(error, 'Failed to load the Sources list');
    });
}

// Recursive function to parse incident types and property types
function parseItems(item) {
    let result = {}

    if (Object.hasOwn(item, 'id') && Object.hasOwn(item, 'name')) {
        result.id = item.id
        result.label = item.name

        if (Object.hasOwn(item, 'children') && item.children.length > 0) {
            result.children = []

            item.children.forEach((children) => {
                result.children.push(parseItems(children))
            })
        }
    }

    return result
}


const formatSize = (bytes) => {
    const k = 1024;
    const dm = 3;
    const sizes = $primevue.config.locale.fileSizeTypes;

    if (bytes === 0) {
        return `0 ${sizes[0]}`;
    }

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

    return `${formattedSize} ${sizes[i]}`;
};

const onSelectedFiles = (event) => {

    console.log('onSelectedFiles', event)

    files.value = event.files;
    files.value.forEach((file) => {
        totalSize.value += parseInt(formatSize(file.size));
    });
};

function onFileUpload(event) {
    learningOutcomeSaving.value = true
    unsavedData.value = true

    let filesSaved = 0

    if (typeof event !== 'undefined') {
        if (Object.hasOwn(event, 'files') && Array.isArray(event.files)) {
            console.log(event.files[0])

            const formData = new FormData();
            formData.append('file', event.files[0]);

            event.files.forEach((file) => {
                console.log('file', file)

                const formData = new FormData();
                formData.append('file', file);

                authApi.post(`/v2/upload?company_id=${company_id.value}`, formData, { headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }).then(response => {
                    console.log(response)

                    if (response.statusCode === 201) {

                        console.log('debrief saved (patch)', response)

                        if (Object.hasOwn(response, 'data')) {
                            filesSaved++

                            console.log('filesSaved', filesSaved)
                            console.log('event.files.length', event.files.length)

                            if (filesSaved >= event.files.length) {
                                learningOutcomeSaving.value = false
                            }

                            learningOutcome.value.attachments.push({
                                id: response.data.id,
                                caption: response.data.original_name,
                                description: response.data.original_name,
                            })
                        }
                    }
                }).catch((error) => {
                    showToast(error, 'Failed to save the file ');
                })
            })
        }
    }
}

const onRemoveTemplatingFile = (file, removeFileCallback, index) => {
    removeFileCallback(index);
    totalSize.value -= parseInt(formatSize(file.size));
    totalSizePercent.value = totalSize.value / 10;
};

function stripTags(str) {
    if (str === null ) {
        str = 'N.A.'
    }

    let doc = new DOMParser().parseFromString(str, 'text/html');
    return doc.body.textContent || "";
}

</script>

<style scoped>
.field {
    margin: 0.75rem 0;
    font-size: 1rem;
}
.field > label {
    display: block;
}
.field > span {
    /* display: block; */
    opacity: 0.7;
    margin-left: 4px;
}
.field span.p-tag {
    display: inline-block;
    opacity: 1;
}

.lo-header {
    border: 1px solid #E4E5E5;
    background: #F6F9FE;
    color: #515C66;
}

</style>